export default "/app/global-wrapper-client/static/5bf543ae52733eb29c273fc24f45e983.woff";